import superagent from 'superagent'

const huntResultsData = {
  getLandUse: (layerId, unitName, token) => {
    return new Promise((resolve, reject) => {
      superagent
        .get(`${__API_URI__}/HuntingUnit/GetLandUse?layerId=${layerId}&UnitName=${unitName}`)
        .set('Authorization', `Bearer ${token}`)
        .set('Content-Type', 'application/json')
        .set('Platform', 'Web')
        .set('Version', `${__version__}`)
        .end((err, res) => {
          if (err) {
            return reject(err)
          } else {
            resolve(res.body)
          }
        })
    })
  },
  getHuntData: (id, unitId, token) => {
    return new Promise((resolve, reject) => {
      superagent
        .get(`${__API_URI__}/FilterHuntModel/GetHuntData/${id}?unitId=${unitId}`)
        .set('Authorization', `Bearer ${token}`)
        .set('Content-Type', 'application/json')
        .set('Platform', 'Web')
        .set('Version', `${__version__}`)
        .end((err, res) => {
          if (err) {
            return reject(err)
          } else {
            resolve(res.body)
          }
        })
    })
  }
}

export default huntResultsData
